const weekDays = ['Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.', 'So.']
const months = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
]

const injectDatePickerHeaderStyles = () => {
  const styleId = 'date-picker-modal-header-styles'

  // Check if styles already exist
  if (document.getElementById(styleId)) {
    return
  }

  // Create style element
  const style = document.createElement('style')
  style.id = styleId
  style.innerHTML = `
  /* Base button styles */
  .MuiButtonBase-root {
    color: inherit;
    border: 0;
    cursor: pointer;
    margin: 0;
    display: inline-flex;
    outline: 0;
    padding: 0;
    position: relative;
    align-items: center;
    user-select: none;
    border-radius: 0;
    vertical-align: middle;
    -moz-appearance: none;
    justify-content: center;
    text-decoration: none;
    background-color: transparent;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  .MuiButtonBase-root::-moz-focus-inner {
    border-style: none;
  }

  /* Icon button styles */
  .MuiIconButton-root {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.54);
    padding: 12px;
    overflow: visible;
    font-size: 1.5rem;
    text-align: center;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border-radius: 50%;
  }
  .MuiIconButton-root:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  @media (hover: none) {
    .MuiIconButton-root:hover {
      background-color: transparent;
    }
  }
  .MuiIconButton-label {
    width: 100%;
    display: flex;
    align-items: inherit;
    justify-content: inherit;
  }

  /* Input adornment styles (used in generateInputField.js) */
  .MuiInputAdornment-root {
    height: 0.01em;
    display: flex;
    max-height: 2em;
    align-items: center;
    white-space: nowrap;
  }
  .MuiInputAdornment-positionEnd {
    margin-left: 8px;
  }

  /* Day picker styles */
  .MuiPickersDay-day {
    color: rgba(0, 0, 0, 0.87);
    width: 36px;
    height: 36px;
    margin: 0 2px;
    padding: 0;
    font-size: 0.75rem;
    font-weight: 500;
  }
  .MuiPickersDay-hidden {
    opacity: 0;
    pointer-events: none;
  }
  .MuiPickersDay-daySelected {
    color: #fff;
    font-weight: 500;
    background-color: #3f51b5;
  }
  .MuiPickersDay-daySelected:hover {
    background-color: #3f51b5;
  }

  /* Slide transition container */
  .MuiPickersSlideTransition-transitionContainer {
    display: block;
    position: relative;
  }

  /* Calendar header styles */
  .MuiPickersCalendarHeader-switchHeader {
    display: flex;
    margin-top: 4px;
    align-items: center;
    margin-bottom: 8px;
    justify-content: space-between;
  }
  .MuiPickersCalendarHeader-transitionContainer {
    width: 100%;
    height: 23px;
    overflow: hidden;
  }
  .MuiPickersCalendarHeader-iconButton {
    z-index: 1;
    background-color: #fff;
  }
  .MuiPickersCalendarHeader-daysHeader {
    display: flex;
    max-height: 16px;
    align-items: center;
    justify-content: center;
  }
  .MuiPickersCalendarHeader-dayLabel {
    color: rgba(0, 0, 0, 0.38);
    width: 36px;
    margin: 0 2px;
    text-align: center;
  }

  /* Calendar container styles */
  .MuiPickersCalendar-transitionContainer {
    margin-top: 12px;
    min-height: 216px;
  }
  .MuiPickersCalendar-week {
    display: flex;
    justify-content: center;
  }

  /* Base picker container styles */
  .MuiPickersBasePicker-container {
    display: flex;
    flex-direction: column;
  }
  .MuiPickersBasePicker-pickerView {
    display: flex;
    max-width: 325px;
    min-width: 310px;
    min-height: 305px;
    overflow-x: hidden;
    flex-direction: column;
    justify-content: center;
  }

  /* DatePicker dropdown wrapper */
  .DatePicker.dropdown-wrapper {
    display: none;
    position: absolute;
    top: 30px;
    right: 20px;
    z-index: 2000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: .6rem;
    max-height: unset;
  }

  /* Typography styles */
  .MuiTypography-alignCenter {
    text-align: center;
  }
  .MuiTypography-root.MuiTypography-body2.MuiTypography-colorInherit {
    height: 12px;
    font-size: 12px;
  }
  `

  // Inject into document head
  document.head.appendChild(style)
}

const generateCalendarDays = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const selectedDay = date.getDate()

  // Get first day of the month and number of days in the month
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)
  const daysInMonth = lastDay.getDate()
  const firstDayOfWeek = firstDay.getDay() // 0 = Sunday, 1 = Monday, etc.

  // Convert Sunday (0) to be last (6) for Monday-first calendar
  const adjustedFirstDay = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1

  // Get days from previous month to fill the first week
  const prevMonth = new Date(year, month, 0)
  const daysInPrevMonth = prevMonth.getDate()
  const prevMonthYear = prevMonth.getFullYear()
  const prevMonthMonth = prevMonth.getMonth()
  const prevMonthDays = []
  for (let i = adjustedFirstDay - 1; i >= 0; i--) {
    const day = daysInPrevMonth - i
    const dayDate = new Date(prevMonthYear, prevMonthMonth, day)
    prevMonthDays.push({
      day,
      year: prevMonthYear,
      month: prevMonthMonth,
      date: dayDate,
      isCurrentMonth: false,
      isSelected: false,
    })
  }

  // Get all days of current month
  const currentMonthDays = []
  for (let day = 1; day <= daysInMonth; day++) {
    const dayDate = new Date(year, month, day)
    currentMonthDays.push({
      day,
      year,
      month,
      date: dayDate,
      isCurrentMonth: true,
      isSelected: day === selectedDay,
    })
  }

  // Calculate days needed from next month to fill the last week
  const totalDays = prevMonthDays.length + currentMonthDays.length
  const remainingDays = 42 - totalDays // 6 weeks * 7 days = 42
  const nextMonthYear = month === 11 ? year + 1 : year
  const nextMonthMonth = month === 11 ? 0 : month + 1
  const nextMonthDays = []
  for (let day = 1; day <= remainingDays; day++) {
    const dayDate = new Date(nextMonthYear, nextMonthMonth, day)
    nextMonthDays.push({
      day,
      year: nextMonthYear,
      month: nextMonthMonth,
      date: dayDate,
      isCurrentMonth: false,
      isSelected: false,
    })
  }

  // Combine all days
  const allDays = [...prevMonthDays, ...currentMonthDays, ...nextMonthDays]

  // Group into weeks
  const weeks = []
  for (let i = 0; i < allDays.length; i += 7) {
    weeks.push(allDays.slice(i, i + 7))
  }

  return weeks
}

const generateDayButton = (dayData) => {
  const classes = [
    'MuiButtonBase-root',
    'MuiIconButton-root',
    'MuiPickersDay-day',
    dayData.isCurrentMonth ? '' : 'MuiPickersDay-hidden',
    dayData.isSelected ? 'MuiPickersDay-daySelected' : '',
  ]
    .filter(Boolean)
    .join(' ')

  const tabindex = dayData.isCurrentMonth ? '0' : '-1'

  // Format date as YYYY-MM-DD string
  const dateString = dayData.date
    ? dayData.date.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })
    : ''

  return `
    <div role="presentation">
      <button class="${classes}" tabindex="${tabindex}" type="button" data-date="${dateString}">
        <span class="MuiIconButton-label">
          <p class="MuiTypography-root MuiTypography-body2 MuiTypography-colorInherit">${dayData.day}</p>
        </span>
        <span class="MuiTouchRipple-root"></span>
      </button>
    </div>`
}

// Make navigation functions globally accessible
if (typeof window !== 'undefined') {
  window.navigateDatePickerMonth = (direction, calendarContainer) => {
    const currentDateStr = calendarContainer.getAttribute('data-current-date')
    const currentDate = currentDateStr ? new Date(currentDateStr) : new Date()

    const newDate = new Date(currentDate)
    if (direction === 'prev') {
      newDate.setMonth(newDate.getMonth() - 1)
    } else if (direction === 'next') {
      newDate.setMonth(newDate.getMonth() + 1)
    }

    // Update the calendar
    window.updateDatePickerCalendar(calendarContainer, newDate)
  }

  window.updateDatePickerCalendar = (calendarContainer, date) => {
    // Update the date attribute
    calendarContainer.setAttribute('data-current-date', date.toISOString())

    // Update month/year display
    const monthYearElement = calendarContainer.querySelector(
      '.MuiPickersCalendarHeader-transitionContainer p'
    )
    if (monthYearElement) {
      monthYearElement.textContent = `${months[date.getMonth()]} ${date.getFullYear()}`
    }

    // Regenerate calendar days
    const weeks = generateCalendarDays(date)

    // Update the calendar weeks
    const calendarTransitionContainer = calendarContainer.querySelector(
      '.MuiPickersCalendar-transitionContainer > div'
    )
    if (calendarTransitionContainer) {
      calendarTransitionContainer.innerHTML = weeks
        .map(
          (week) => `
        <div class="MuiPickersCalendar-week">
          ${week.map((dayData) => generateDayButton(dayData)).join('')}
        </div>`
        )
        .join('')
    }
  }
}

const generateDatePickerModal = (date = new Date()) => {
  console.log(date)

  // Inject header styles if they don't exist
  injectDatePickerHeaderStyles()

  // Generate calendar days
  const weeks = generateCalendarDays(date)

  // Store date as ISO string for navigation
  const dateISOString = date.toISOString()

  return `<div class="MuiPaper-root MuiPopover-paper MuiPaper-elevation8 MuiPaper-rounded DatePicker dropdown-wrapper" data-current-date="${dateISOString}">
<div class="MuiPickersBasePicker-container">
  <div class="MuiPickersBasePicker-pickerView">
    <div>
      <div class="MuiPickersCalendarHeader-switchHeader">
        <button class="MuiButtonBase-root MuiIconButton-root MuiPickersCalendarHeader-iconButton"
          tabindex="0" type="button" data-direction="prev">
          <span class="MuiIconButton-label">
            <span role="img" class="anticon">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.47159 11.0739L0.306818 5.90909L5.47159 0.744318L6.49432 1.76705L3.07955 5.17045H12V6.64773H3.07955L6.49432 10.0568L5.47159 11.0739Z"
                  fill="black"></path>
              </svg>
            </span>
          </span>
          <span class="MuiTouchRipple-root"></span>
        </button>
        <div
          class="MuiPickersSlideTransition-transitionContainer MuiPickersCalendarHeader-transitionContainer">
          <p class="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter">${months[date.getMonth()]} ${date.getFullYear()}</p>
        </div>
        <button class="MuiButtonBase-root MuiIconButton-root MuiPickersCalendarHeader-iconButton"
          tabindex="0" type="button" data-direction="next">
          <span class="MuiIconButton-label">
            <span role="img" class="anticon">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.52841 11.0739L11.6932 5.90909L6.52841 0.744318L5.50568 1.76705L8.92045 5.17045H0V6.64773H8.92045L5.50568 10.0568L6.52841 11.0739Z"
                  fill="black"></path>
              </svg>
            </span>
          </span>
          <span class="MuiTouchRipple-root"></span>
        </button>
      </div>
      <div class="MuiPickersCalendarHeader-daysHeader">
        ${weekDays.map((day) => `<span class="MuiTypography-root MuiPickersCalendarHeader-dayLabel MuiTypography-caption">${day}</span>`).join('')}
      </div>
    </div>
    <div
      class="MuiPickersSlideTransition-transitionContainer MuiPickersCalendar-transitionContainer">
      <div class="">
        ${weeks
          .map(
            (week) => `
        <div class="MuiPickersCalendar-week">
          ${week.map((dayData) => generateDayButton(dayData)).join('')}
        </div>`
          )
          .join('')}
      </div>
    </div>
  </div>
</div>
`
}
